import Glide from '@glidejs/glide'

if (document.querySelector(".slider")) {
    new Glide(".slider", {
        type:'carousel',
        autoheight: true,
        autoplay:6000,
        hoverpause:true,
        animationDuration:1000,
    }).mount();
}


if (document.querySelector(".slider__goods")) {
    new Glide(".slider__goods", {
        type:'carousel',
        autoheight: true,
        hoverpause:true,
        animationDuration:1000,
        breakpoints: {
            320:{
                perView: 2,
                gap: 10
            },
            500:{
                perView: 2,
                gap: 10
            },
            768:{
                perView: 3,
                gap: 15
            },
            1024:{
                perView: 4,
                gap: 20
            },
            1200:{
                perView: 4,
                gap: 20
            },
            1920:{ 
                perView: 4,
                gap: 15
            },
            2560:{
                perView: 4,
                gap: 20
            }
          }
    }).mount();
}

if (document.querySelector(".slider__product")) {
    new Glide(".slider__product", {
        type:'carousel',
        autoheight: true,
        hoverpause:true,
        animationDuration:1000,
    }).mount();
}

// if (document.querySelector(".slider__about")) {
//     new Glide(".slider__about", {
//         type:'carousel',
//         autoheight: true,
//         autoplay:6000,
//         hoverpause:true,
//         animationDuration:1000,
//     }).mount();
// }